export const conditionOptions = [
  {
    value: 'eq',
    label: '选中'
  },
  {
    value: 'contain',
    label: '包含'
  },
  {
    value: 'contain_keywords',
    label: '包含关键词'
  },
  {
    value: 'gt',
    label: '大于',
    types: ['RATE']
  },
  {
    value: 'ge',
    label: '大于等于',
    types: ['RATE']
  },
  {
    value: 'lt',
    label: '小于',
    types: ['RATE']
  },
  {
    value: 'le',
    label: '小于等于',
    types: ['RATE']
  }

]
export const parameterOptions = [
  {
    value: 'contain_keywords',
    label: '包含关键词',
  },
]